
















































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import OrderApi from '@/api/order/list'
import ViewUI from 'view-design'
@Component({
  components: {
    CustomForm,
  },
})
export default class ShopOrders extends AbpBase {
  //  filter = [
  //   {
  //     label: '输入搜索：',
  //     type: 'input',
  //     props: {
  //       placeholder: '请输入关键字',
  //     },
  //     key: 'Keyword',
  //   },
  // ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '订单编号',
      key: 'orderNo',
      align: 'center',
    },
    // {
    //   title: '管易单号',
    //   key: 'tradeNo',
    //   align: 'center',
    // },
    {
      title: '商品信息',
      slot: 'orderItems',
      width: 300,
      align: 'center',
    },
    {
      title: '订单金额',
      slot: 'payAmount',
      align: 'center',
    },
    {
      title: '订单类型',
      slot: 'orderType',
      align: 'center',
    },
    {
      title: '收货人',
      slot: 'shippingAddress',
      align: 'center',
    },
    {
      title: '订单状态',
      key: 'orderFullStatusStr',
      align: 'center',
    },
    {
      title: '下单时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  loading: boolean = false
  tableData: any[] = []
  page = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }
  mounted() {
    let { storeId, productId } = this.$route.query
    if(storeId && productId) {
      this.getOrderList(storeId.toString(),productId.toString())
    }
  }

  // onSubmit(form, valid) {
  //   if (valid) {
  //     this.getOrderList(form)
  //   } else {
  //     this.$Message.error('验证失败')
  //   }
  // }
  // submitFn() {
  //   let form: any = this.$refs.lineForm
  //   form.submit()
  // }

  orderTypeString(type) {
    let text = type
    switch (type) {
      case 0:
        text = '常规订单'
        break
      case 1:
        text = '拼团订单'
        break
      case 2:
        text = '积分订单'
        break
      case 3:
        text = '预售订单'
        break
    }

    return text
  }

  changePage(e) {
    this.page.currentPage = e
    let { storeId, productId } = this.$route.query
    this.getOrderList(storeId.toString(),productId.toString())
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    let { storeId, productId } = this.$route.query
    this.getOrderList(storeId.toString(),productId.toString())
  }

  /**
   * 获取订单列表
   */
  getOrderList(storeId, productId) {
    let { page } = this
    // let Keyword = form ? form['Keyword'] : null
    this.loading = true
    OrderApi.getOrderList(page.maxResultCount, page.currentPage, 0, '', '', '', '', null, null, '', productId, storeId)
      .then((res) => {
        this.loading = false
        if (res.data) {
          this.tableData = res.data.items
          page.totalCount = res.data.totalCount
        }
      })
      .catch((err) => {
        this.loading = false
      })
  }
  /**
   * 查看订单详情
   */
  orderDetailFn(row) {
    this.$router.push({
      name: 'orderDetail',
      query: {
        id: row.id,
      },
    })
  }
}
